export default __webpack_public_path__ + "static/media/3bcd23802b27298921f03f65eae4bf73.jpg";